export default {"src":"/_next/static/media/oneplus_logo.9a39e88d.svg","height":61,"width":271};